import React from 'react'
import classNames from 'classnames'

export type MetaTextProps = React.ComponentPropsWithoutRef<'div'>

export const MetaText = ({ className, ...rest }: MetaTextProps) => (
  <div
    className={classNames('testimonial-card__meta-text', className)}
    {...rest}
  />
)
